// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"341":"elections","603":"AdminSettings","791":"elections-admin"}[chunkId] || chunkId) + "." + {"200":"10889a50","341":"d0e346ad","603":"a65c36ad","791":"c36bcf5a"}[chunkId] + ".css";
};